import MarkSafe from '../../../../../general/components/MarkSafe';

const Message = ({date, text}) => (
    <li>
        <span className="metar-date">{date}</span>
        <MarkSafe element="span" className="metar-string" value={text} />
    </li>
);

export default Message;
